const formatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS'
});
export default function moneyFormat(value) {
    return formatter.format(value);
}